var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"height":"64","fixed":!_vm.notFixedRoute}},_vm._l((_vm.footerMenu),function(item,index){return _c('v-btn',{key:`${item.title}${index}`,attrs:{"plain":""},on:{"click":function($event){return _vm.goTo(item.to)}}},[_vm._v(" "+_vm._s(_vm.$t(item.title))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }